<template>

  <div class="wall-cells" :class="{ loading: this.$store.state.loading }">
    <BTCell @validate="validate" v-for="(cabcellData,index) in cabData"
            :key="index"
            :cellData="cabcellData"
            :calculateDt="cellsData"
            :index="index"
    />
  </div>

</template>

<script>
import BTCell from "@/components/BookingTable/BTCell";
// import {dateFormat} from "@/dateFormat";

export default {
  name: 'BTWallCell',
  components: {
    BTCell
  },
  inject: ['officeId', 'selectData', 'mySelectData'],
  props: {
    cabId: Number,
    cabData: Object,
    startTime: String,
    endTime: String,
    timeZone:String
    // officeId: Number
  },
  data() {
    return {
      cellsData: {},
      cabType: 0,
      startTimeLocal: "10:00",
      endTimeLocal: "22:00"
    }
  },
  beforeUpdate() {
    this.buildCalcData();
  },
  updated() {
    // console.log('WAll updated')
    // console.log(this.cabId, this.cellsData)
    // this.buildCalcData();
  },
  created() {
    this.startTimeLocal = this.startTime ? this.startTime : this.startTimeLocal
    this.endTimeLocal = this.endTime ? this.endTime : this.endTimeLocal
    this.cabType = this.getCabinetType()
    // console.log('created')ss
    this.buildCalcData();
    //this.$emitter.off('revalidate_walls_'+ this.officeId)
    // подписываемся на событие перепроверки правил
    this.$emitter.on('revalidate_walls_' + this.officeId, () => {
      this.revalidate()
    })
  },

  computed: {
    getSelfBooking: function () {
      let data = this.$store.state.booking.data
      if (this.isSet(data[this.officeId]) && this.isSet(data[this.officeId][this.cabId])) {
        return data[this.officeId][this.cabId]
      }
      return false
    },
  },
  methods: {
    getCabinetType() {
      return this.$store.state.cabinet.data.cabinetsInfo[this.officeId][this.cabId]['type']
    },
    getStoreSelectNew() {
      return Object.assign({}, {'a': 'b'});
      // return this.$store.state
    },
    revalidate() {
      // console.log('Обновляюсь officeId' + this.officeId+' cab_id '+this.cabId)
      this.buildCalcData();
    },
    validate() {
      // console.log('validate')
      // this.$emit("validate");
      // this.buildCalcData();
      // отправляем событие на перепроверку всех правил во всех кабинетах
      this.$emitter.emit('revalidate_' + this.officeId)
    },

    isSet(val) {
      return typeof val !== 'undefined'
    },

    buildCalcData() {
      // console.log('buildCalcData')
      // this.startTimeLocal = "08:30"
      // this.endTimeLocal = "21:30"
      let
          res = []
          , oldPrice = null
          , oldBooking = false
          , _data = this.cabData
          // , _data = Object.assign({},this.cabData)
          , bookingData = this.getSelfBooking
          // , bookingData = Object.assign({},this.getSelfBooking)
          // , datenowStamp = Date.now()
          // , datenowStamp = dateFormat.getDateNowWithTimeZone().getTime()
          , startHour = Number(this.startTimeLocal.split(":")[0])
          , startMinute = Number(this.startTimeLocal.split(":")[1])
          , endHour = Number(this.endTimeLocal.split(":")[0])
          , endMinute = Number(this.endTimeLocal.split(":")[1])
          , fkey = false

      // текущее время с учетом timezone
      const timeZone = String(this.timeZone); // Часовой пояс
      const [hours, minutes] = timeZone.split(":").map(Number);
      const offsetMinutes = hours * 60 + (hours < 0 ? -minutes : minutes); // Минуты смещения

      const now = new Date();
      const utcTimestamp = now.getTime() + now.getTimezoneOffset() * 60 * 1000; // Метка времени в UTC
      const datenowStamp = utcTimestamp + offsetMinutes * 60 * 1000; // Учёт часового пояса




      for (var key in _data) {


        let
            d = _data[key]

            , sKey = this.officeId + ':' + d.cabinetId + ':' + d.hour + ':' + d.minute
            , booking = bookingData && this.isSet(bookingData[d.hour]) && this.isSet(bookingData[d.hour][d.minute])
            , bookingParam = booking && bookingData[d.hour][d.minute]
            , myBooking = booking && bookingParam && bookingParam['isOwner']
            // , myBooking = booking //todo тест - раскомменировать когда будет my работать booking && bookingParam['isOwner']
            , minute = d.minute === '1/2' ? 0 : 30
            , display = d.hour >= startHour && d.hour <= endHour
            , viewPrice = d.price !== oldPrice || oldBooking !== Boolean(booking)
            , isLast = false
            , select = this.isSet(this.selectData[sKey])
            , mySelect = this.isSet(this.mySelectData[sKey])
            , cancelRetention = false

        if (
            (d.hour === startHour && minute === 0  && startMinute === 30) ||
            (d.hour === endHour && endMinute === 30 && minute !== 0) ||
            (endMinute === 0 && d.hour === endHour)
        ) {
          display = false;
        }

        if (booking) {
          let
              cancelStamp = Number(d.cancelTime) * 3600 * 1000
              , minute = bookingParam['minute'] == '2/2' ? '30' : '00'
              , currDate = bookingParam['date'] + 'T' + bookingParam['hour'] + ':' + minute + ':00'
              , stamp = Date.parse(currDate)
          // Делаем удержание если время отмены истекло
          // ввели разрешение отмены без удержания в течении 2 часов после создания
          // параметр canFullReturn отображает можно ли отменить или нельзя в течении 2 часов и далее по истечению максимального времени отмены
          if (!bookingParam['canFullReturn'] && !(datenowStamp < (stamp - cancelStamp))) {
            cancelRetention = true
          }
          // console.log(bookingParam,minute,currDate,stamp)
        }
        let brickMinute = d.minute == '2/2' ? '30' : '00'
        let _hour = d.hour < 10 ? '0' + d.hour : d.hour;
        let brickTimeIso = this.$store.state.date + 'T' + _hour + ':' + brickMinute + ':00';
        let brickStamp = new Date(brickTimeIso).getTime()
        let outOfDate = brickStamp < datenowStamp


        /*
        * 1 - free
        * 2 - busy
        * 3 - my
        * 4 - selected
        * 5 - selmybooking
        * 6 - my expired // мой и уже время наступило
        * 7 - уже время наступило
        */
        let status = 1
        status = !display ? 0 : status; // выходит за рамки времени бронирования
        status = booking ? 2 : status;
        status = myBooking ? 3 : status;
        status = select ? 4 : status;
        status = mySelect ? 5 : status;
        status = outOfDate ? 7 : status;
        status = myBooking && outOfDate ? 6 : status; // new

        // console.log(myBooking)
        if (key > 0 && viewPrice) {
          res[key - 1]['isLast'] = true;
        }


        res[key] = {
          outOfDate: outOfDate,
          display: display, // обрезка часов с 10 до 21, так как бронирование не принимает на 9 часов и 22
          viewPrice: viewPrice,
          isFirst: viewPrice,
          isEndWorkDay: d.hour >= 17,
          isLast: isLast,
          isBooking: booking,
          isMyBooking: myBooking,
          select: select,
          status: status,
          sKey: sKey,
          cabinetType: this.cabType,
          bookingParam: bookingParam,
          cancelRetention: cancelRetention
        };

        if (display && !outOfDate) {
          oldPrice = d.price
          oldBooking = booking
        }
        if(display === true){
          fkey = key
        }

      }

      if (typeof res[fkey] !== 'undefined') {
        res[fkey]['isLast'] = true;
      }


      this.validateCalcData(res, this)

      this.cellsData = res
    },

    validateCalcData(res, _this) {

      let l = res.length

      res.forEach(function (item, index, array) {
        let itemPrev = index ? array[index - 1]['status'] : 0;
        let itemPrevPrev = index > 1 ? array[index - 2]['status'] : 0;
        let itemNext = index < (l - 1) ? array[index + 1]['status'] : 0;
        let itemNextNext = index < (l - 2) ? array[index + 2]['status'] : 0;
        let error = false;
        /*
        * 1 - free
        * 2 - busy
        * 3 - my
        * 4 - selected
        * 5 - selmybooking
        * 6 - my expired // мой и уже время наступило
        * 7 - уже время наступило
        */
        //1 hours
        if (item['status'] === 4 && (itemPrev === 1 || itemPrev === 2 || !itemPrev || itemPrev === 7) && (itemNext === 1 || itemNext === 2 || !itemNext)) {
          // res[index]['error'] = true;

          error = '1hours';
          // Отменяем ошибку "Нельзя бронировать 30 минут", если впереди и в конце занято
          if ((!itemPrev || itemPrev === 2 || itemPrev === 7) && (!itemNext || itemNext === 2)) {
            error = false;
          }
          // console.log('1 hours');
          // правило соседних кабинетов. Можно продлевать в соседнем если есть предыдущие выбранные или забронированные

          // 1 проверяем что предыдущая ячейка текущего кабинета занята
          if (error != false) {
            let bd = _this.$store.state.booking.data
            // получаем текущий час и минуты ячейки
            let keyData = item['sKey'].split(':');
            let currentCabId = keyData[1];
            let hour = Number(keyData[2]);
            let minute = keyData[3];
            // выбираем час и минуты для поиска предыдущих броней/селектов в соседнем кабинете ранее
            let srhHourPrev = minute == '2/2' ? hour : hour - 1;
            let srhMinutePrev = minute == '2/2' ? '1/2' : '2/2';

            let srhHourNext = minute == '2/2' ? hour + 1 : hour;
            let srhMinuteNext = minute == '2/2' ? '1/2' : '2/2';

            // начинаем поиск в селекторе
            // console.log(_this.$store.state.selector.new);
            for (let key in _this.$store.state.selector.new) {
              // найдем выбранные ячейки на пол часа ранее в соседнем кабинете
              let searchKeyData = key.split(':');
              let officeId = searchKeyData[0];
              let cabId = searchKeyData[1];
              let sHour = searchKeyData[2];
              let sMinute = searchKeyData[3];
              // смотрим выбрана ли ячейка в каком либо кабинете на предыдущие пол часа
              if (sHour == srhHourPrev && sMinute == srhMinutePrev) {

                // если после пред ячейки след занята
                if (
                    officeId in bd &&
                    cabId in bd[officeId] &&
                    hour in bd[officeId][cabId] &&
                    minute in bd[officeId][cabId][hour] &&
                    bd[officeId][cabId][hour][minute]['isOwner'] == false
                ) {
                  error = false
                }
              }

              if (sHour == srhHourNext && sMinute == srhMinuteNext) {
                // если след ячейка занята
                if (
                    officeId in bd &&
                    currentCabId in bd[officeId] &&
                    srhHourNext in bd[officeId][currentCabId] &&
                    srhMinuteNext in bd[officeId][currentCabId][srhHourNext] &&
                    bd[officeId][currentCabId][srhHourNext][srhMinuteNext]['isOwner'] == false
                ) {
                  error = false
                }
              }
            }
            // если в селекторе нет, посмотрим мои брони
            if (error != false) {
              // officeId  cabId isOwner
              // если в предыдущей ячейке в соседнем кабинете есть моя бронь и следующая после брони занята
              for (let cabId in bd[_this.officeId]) {
                if (
                    srhHourPrev in bd[_this.officeId][cabId] &&
                    srhMinutePrev in bd[_this.officeId][cabId][srhHourPrev] &&
                    bd[_this.officeId][cabId][srhHourPrev][srhMinutePrev]['isOwner'] == true &&
                    hour in bd[_this.officeId][cabId] &&
                    minute in bd[_this.officeId][cabId][hour] &&
                    bd[_this.officeId][cabId][hour][minute]['isOwner'] == false
                ) {
                  error = false
                }
                // console.log(bd[_this.officeId][cabId])
              }
            }

            // console.log(hour, minute, srhHourPrev, srhMinutePrev);
          }
        }

        //RangeHour
        if (item['status'] === 1 && (itemPrev === 4 || itemPrev === 3) && (itemPrevPrev === 4 || itemPrevPrev === 3 || itemPrevPrev === 7)
            && (itemNext === 4 || itemNext === 3) && (itemNextNext === 4 || itemNextNext === 3)) {
          error = 'RangeHour';
          // console.log('RangeHour');
          /*
        * 1 - free
        * 2 - busy
        * 3 - my
        * 4 - selected
        * 5 - selmybooking
        * 6 - my expired // мой и уже время наступило
        * 7 - уже время наступило
        */
        }

        //MyRangeHour
        if (item['status'] === 5 && itemPrev === 3 && itemNext === 3) {
          error = 'MyRangeHour';
          // console.log('MyRangeHour');
        }

        //MyOneHour
        if (item['status'] === 3 && itemPrev !== 3 && itemPrev !== 6 && itemNext !== 3 && itemPrev !== 7) {
          let tmpError = error // сохраним значение error
          error = 'MyOneHour';

          // Отменяем ошибку "Нельзя бронировать 30 минут", если впереди и в конце занято
          if ((!itemPrev || itemPrev === 2) && (!itemNext || itemNext === 2)) {
            error = tmpError; // вернем значение error
          }
          // console.log('MyOneHour');

          if (error != false) {
            let bd = _this.$store.state.booking.data
            // получаем текущий час и минуты ячейки
            let keyData = item['sKey'].split(':');
            // let currentCabId = keyData[1];
            let hour = Number(keyData[2]);
            let minute = keyData[3];
            // выбираем час и минуты для поиска предыдущих броней/селектов в соседнем кабинете ранее
            let srhHourPrev = minute == '2/2' ? hour : hour - 1;
            let srhMinutePrev = minute == '2/2' ? '1/2' : '2/2';

            let srhHourNext = minute == '2/2' ? hour + 1 : hour;
            let srhMinuteNext = minute == '2/2' ? '1/2' : '2/2';

            for (let cabId in bd[_this.officeId]) {

              let mySelPrevKey = _this.officeId + ':' + cabId + ':' + srhHourPrev + ':' + srhMinutePrev;
              let mySelNextKey = _this.officeId + ':' + cabId + ':' + srhHourNext + ':' + srhMinuteNext;
              if (
                  (
                      // если есть бронь в соседнем кабинете ранее
                      srhHourPrev in bd[_this.officeId][cabId] &&
                      srhMinutePrev in bd[_this.officeId][cabId][srhHourPrev] &&
                      bd[_this.officeId][cabId][srhHourPrev][srhMinutePrev]['isOwner'] == true &&
                      // и не выбрано на снятие брони
                      !(mySelPrevKey in _this.$store.state.selector.my)
                  ) || (
                      // если есть бронь в соседнем кабинете позднее
                      srhHourNext in bd[_this.officeId][cabId] &&
                      srhMinuteNext in bd[_this.officeId][cabId][srhHourNext] &&
                      bd[_this.officeId][cabId][srhHourNext][srhMinuteNext]['isOwner'] == true &&
                      // и не выбрано на снятие брони
                      !(mySelNextKey in _this.$store.state.selector.my)
                  )
              ) {
                error = false
              }
            }

          }
        }

        if (error) {
          _this.$store.dispatch('selector/setError', {
            sKey: item['sKey'],
            typeError: error,
            isMy: item['isMyBooking']
          })
        } else {
          _this.$store.dispatch('selector/deleteError', {
            sKey: item['sKey'],
            isMy: item['isMyBooking']
          })
        }
        // if(error){
        //   _this.$store.commit('selector/setError', {
        //     sKey:item['sKey'],
        //     typeError:error,
        //     isMy:item['isMyBooking']
        //   })
        // } else{
        //   _this.$store.commit('selector/deleteError', {
        //     sKey:item['sKey'],
        //     isMy:item['isMyBooking']
        //   })
        // }
      });
    },
  }
}
</script>

<style scoped>

.wall-cells {

  position: relative;
  display: flex;
  /*display: inline-flex;*/
  width: fit-content;
  border-top: 1px solid #f5f5f5;
  max-height: 4rem;
  opacity: 1;
  transition: opacity ease .7s;
}

.vertical .wall-cells{
  flex-direction: column;
  max-height: unset;
  width: 100%;

  margin-left: 1px;
  margin-right: 1px;

}
.vertical .xsize-1 .wall-cells{
  min-width: unset;
}

.vertical .xsize-2 .wall-cells{
  //min-width: calc(100% / 15);
  min-width: 60px;
}

.vertical .xsize-3  .wall-cells{
  //min-width: calc(100% / 10);
  min-width: 100px;
}

.wall-cells.loading {
  opacity: .3;
}

.wall-cells:last-child {
  border-bottom: 1px solid #f5f5f5;
}


@media (max-width: 670px) {
  /*.wall-cells-wrap{*/
  /*  padding-top: 2rem;*/
  /*}*/
  .wall-cells {
    margin-top: 2rem;
    will-change: transform;
  }
}
</style>